
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flash-sale",
      function () {
        return require("private-next-pages/flash-sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flash-sale"])
      });
    }
  